import thunk from 'redux-thunk'
import { browserHistory } from 'react-router'
import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import reducers from './reducers'

const routingMiddleware = routerMiddleware(browserHistory)

const middleWare = [thunk, routingMiddleware]

const createStoreWithMiddleware = applyMiddleware(...middleWare)(createStore)

export const configureStore = (initialState) =>
  createStoreWithMiddleware(reducers, initialState)



// WEBPACK FOOTER //
// ./src/store.js